module.exports = __webpack_public_path__ + "static/stava_img_1-8c5ee114410d4a5d81f1b4624c082137.png";